import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MobileMenuComponent } from '../../components/mobile-menu/mobile-menu.component';

/**
 * This modules is used to access elements outside the MobileModule
 * (not a shared module used to share elements inside the MobileModule)
 */ 

@NgModule({
  declarations: [
    MobileMenuComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    MobileMenuComponent
  ]
})
export class ExportMobileModuleModule { }
